import { render } from "./UserLocationModal.vue?vue&type=template&id=d8492744"
import script from "./UserLocationModal.vue?vue&type=script&lang=js"
export * from "./UserLocationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__